import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import PersonaGenerator from './PersonaGenerator'
import JourneyGenerator from './JourneyGenerator'
import JourneyList from './JourneyList'
import BatchDashboard from './BatchDashboard'

const TABS = [
  { id: 'persona', label: 'Create Persona' },
  { id: 'journey', label: 'Generate Journey' },
  { id: 'view', label: 'View Journeys' },
  { id: 'batch', label: 'Batch & Evaluate' },
]

export default function GeneratorLayout() {
  const [activeTab, setActiveTab] = useState('persona')
  const [lastPersonaId, setLastPersonaId] = useState(null)
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-base-200 flex flex-col">
      {/* Header */}
      <div className="navbar bg-base-100 shadow-sm px-6">
        <div className="flex-1 gap-2">
          <button className="btn btn-ghost btn-sm" onClick={() => navigate('/menu')}>
            ← Menu
          </button>
          <span className="text-lg font-bold">Persona & Episode Generator</span>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex justify-center pt-4 px-4">
        <div className="tabs tabs-boxed bg-base-100">
          {TABS.map(tab => (
            <button
              key={tab.id}
              className={`tab tab-lg ${activeTab === tab.id ? 'tab-active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 p-4 md:p-8 max-w-5xl mx-auto w-full">
        {activeTab === 'persona' && (
          <PersonaGenerator
            onPersonaCreated={(id) => {
              setLastPersonaId(id)
              setActiveTab('journey')
            }}
          />
        )}
        {activeTab === 'journey' && (
          <JourneyGenerator
            preselectedPersonaId={lastPersonaId}
            onJourneyCompleted={() => setActiveTab('view')}
          />
        )}
        {activeTab === 'view' && <JourneyList />}
        {activeTab === 'batch' && <BatchDashboard />}
      </div>
    </div>
  )
}
